var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFramevehicle3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5500_63957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#00838F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3184 16.4082C27.2771 15.9838 27.0001 15.6184 26.5993 15.4651L25.1023 14.8758C24.8783 14.7873 24.6838 14.6282 24.5542 14.4219L22.3734 10.9504C22.1671 10.6203 21.8017 10.4141 21.4068 10.4141H17.894V18.7481H27.5601L27.3184 16.4082Z",
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5699 14.7343L21.5247 11.4808C21.5011 11.4396 21.454 11.416 21.4068 11.416H18.896V14.7343H23.5699Z",
    fill: "#4485C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7369 18.7422H17.894V20.9701H27.7428C28.0139 20.9701 28.232 20.752 28.232 20.4809V19.2314C28.232 18.9662 28.008 18.7422 27.7369 18.7422Z",
    fill: "#DEDEDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0687 7.02539H3.16499C2.71116 7.02539 2.33984 7.39671 2.33984 7.85054V20.9704H17.888V7.85054C17.8939 7.39671 17.5226 7.02539 17.0687 7.02539Z",
    fill: "#FBD303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.888 18.7422H2.33984V20.9701H17.888V18.7422Z",
    fill: "#DEDEDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2453 20.8819C11.2453 19.3024 9.96636 18.0293 8.39269 18.0293C6.81902 18.0293 5.54004 19.3083 5.54004 20.8819C5.54004 20.9114 5.54593 20.9409 5.54593 20.9704H11.2453C11.2453 20.9409 11.2453 20.9114 11.2453 20.8819Z",
    fill: "#333842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9034 18.0293C21.3239 18.0293 20.0508 19.3083 20.0508 20.8819C20.0508 20.9114 20.0567 20.9409 20.0567 20.9704H25.7561C25.7561 20.9409 25.762 20.9114 25.762 20.8819C25.762 19.3083 24.483 18.0293 22.9034 18.0293Z",
    fill: "#333842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9035 23.3334C24.2577 23.3334 25.3554 22.2357 25.3554 20.8816C25.3554 19.5274 24.2577 18.4297 22.9035 18.4297C21.5494 18.4297 20.4517 19.5274 20.4517 20.8816C20.4517 22.2357 21.5494 23.3334 22.9035 23.3334Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.904 22.2445C23.6559 22.2445 24.2655 21.6349 24.2655 20.883C24.2655 20.131 23.6559 19.5215 22.904 19.5215C22.152 19.5215 21.5425 20.131 21.5425 20.883C21.5425 21.6349 22.152 22.2445 22.904 22.2445Z",
    fill: "#DEDEDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39278 23.3334C9.74691 23.3334 10.8447 22.2357 10.8447 20.8816C10.8447 19.5274 9.74691 18.4297 8.39278 18.4297C7.03866 18.4297 5.94092 19.5274 5.94092 20.8816C5.94092 22.2357 7.03866 23.3334 8.39278 23.3334Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39274 22.2445C9.14467 22.2445 9.75424 21.6349 9.75424 20.883C9.75424 20.131 9.14467 19.5215 8.39274 19.5215C7.64081 19.5215 7.03125 20.131 7.03125 20.883C7.03125 21.6349 7.64081 22.2445 8.39274 22.2445Z",
    fill: "#DEDEDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4243 19C23.4243 19.3452 23.1445 19.625 22.7993 19.625C22.4541 19.625 22.1743 19.3452 22.1743 19C22.1743 18.6548 22.4541 18.375 22.7993 18.375C23.1445 18.375 23.4243 18.6548 23.4243 19Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98828 19.2793C8.98828 19.6245 8.70846 19.9043 8.36328 19.9043C8.0181 19.9043 7.73828 19.6245 7.73828 19.2793C7.73828 18.9341 8.0181 18.6543 8.36328 18.6543C8.70846 18.6543 8.98828 18.9341 8.98828 19.2793Z",
    fill: "#414753"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5500_63957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFramevehicle3);
export default __webpack_public_path__ + "static/media/Framevehicle3.c592a2bd6479a47f289f56c9a16bb3e7.svg";
export { ForwardRef as ReactComponent };